<template>
  <el-dialog title="配置结业证书" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
    <el-form :model="form" :rules="rule" ref="form">
      <el-form-item label="培训班名称" :label-width="formLabelWidth">
        <el-input readonly v-model="editParams.skuName" autocomplete="off" placeholder="请输入培训班名称"></el-input>
      </el-form-item>
      <el-form-item label="证书选择" :label-width="formLabelWidth" prop="graduationId">
        <el-select v-model="form.graduationId" @change='change'>
          <el-option v-for="(item,idx) in selectJson" :key="idx" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="red">
        请谨慎选择证书模版，如果更换证书模版，请在培训班通讯录中，为学员重新申请证书
      </div>
      <el-form-item label="证书内容" :label-width="formLabelWidth" prop='certificateContent'>
        <el-input type='textarea' v-model="form.certificateContent" autocomplete="off" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="证书样例" :label-width="formLabelWidth">
        <img :src="imgUrl" alt="" style="max-width:300px">
      </el-form-item>
      <el-form-item label="证书编号" :label-width="formLabelWidth">
        <el-table :data="list" border>
          <!-- <el-table-column label="租户名称" align="center" prop="companyName" min-width="180" :formatter="fliteRData" /> -->
          <el-table-column label="当前年份" align="center" prop="numberYearNow" min-width="180">
            <template v-slot="{ row }">
              <el-input v-model="row.numberYearNow" placeholder="当前年份" @blur="updateList('numberYearNow',row)" oninput="value=value.replace(/[^\d]/g,'')" />
            </template>
          </el-table-column>
          <el-table-column label="岗位名称" align="center" prop="numberPost" min-width="180">
            <template v-slot="{ row }">
              <el-input v-model="row.numberPost" placeholder="岗位名称" @blur="updateList('numberPost',row)" oninput="value=value.replace(/[^\d]/g,'')" />
            </template>
          </el-table-column>
          <el-table-column label="合同签订年" align="center" prop="numberYearSign" min-width="180">
            <template v-slot="{ row }">
              <el-input v-model="row.numberYearSign" placeholder="合同签订年" @blur="updateList('numberYearSign',row)" oninput="value=value.replace(/[^\d]/g,'')" />
            </template>
          </el-table-column>
          <el-table-column label="合同编号" align="center" prop="numberContract" min-width="180">
            <template v-slot="{ row }">
              <el-input v-model="row.numberContract" placeholder="合同编号" @blur="updateList('numberContract',row)" oninput="value=value.replace(/[^\d]/g,'')" />
            </template>
          </el-table-column>
          <el-table-column label="证书起始编号" align="center" prop="numberStartStr" min-width="180">
            <template slot="header">
              <span>证书起始编号</span>
              <el-tooltip class="item" effect="dark" content="证书起始编号位数越多，可颁发证书编号上限约高">
                <i class="el-icon-question" />
              </el-tooltip>
            </template>
            <template v-slot="{ row }">
              <el-input v-model="row.numberStartStr" placeholder="证书起始编号" @blur="updateList('numberStartStr',row)" oninput="value=value.replace(/[^\d]/g,'')" />
            </template>
          </el-table-column>
          <el-table-column label="学员证书编号预览" align="center" min-width="180">
            <template v-slot="{ row }">
              {{row.numberYearNow}}{{row.numberPost}}{{row.numberYearSign}}{{row.numberContract}}{{row.numberStartStr}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
      </el-form-item>
    </el-form>
    <!-- <el-alert title="证书编号" type="success" :closable="false" /> -->
    <br />
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import tableMixins from "@/libs/mixins/table"
import { skuupdate, getCertificateInfo, skuCertificatepage, skuCertificateupdate } from "@/api/product/classManage"
export default {
  components: {},
  mixins: [tableMixins],
  props: {
    editParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      formLabelWidth: "130px",
      selectJson: [],
      form: {},
      rule: {
        graduationId: [{ required: true, message: "请选择证书类型", trigger: "blur" }],
        certificateContent: [{ required: true, message: "请输入证书内容", trigger: "blur" }],
      },
      imgUrl: '',
      list: []
    };
  },
  methods: {
    async getData () {
      const params = {
        ...this.pageInfo,
        skuId: this.editParams.id,
        type: 2
      }
      const res = await skuCertificatepage(params)
      this.total = Number(res.data.total)
      this.list = res.data.records.map(item => {
        item.numberYearNow = item.numberYearNow || ''
        item.numberPost = item.numberPost || ''
        item.numberYearSign = item.numberYearSign || ''
        item.numberContract = item.numberContract || ''
        item.numberStartStr = item.numberStartStr || ''
        return { ...item }
      })
    },
    async updateList (key, item) {
      const value = item[key]
      const companyId = item.companyId
      const skuId = this.editParams.id
      const numberYearNow = item.numberYearNow
      const numberPost = item.numberPost
      const numberYearSign = item.numberYearSign
      const numberContract = item.numberContract
      const numberStartStr = item.numberStartStr
      const obj = { numberYearNow, numberPost, numberYearSign, numberContract, numberStartStr }
      const type = 2
      switch (key) {
        case 'numberYearNow':
          await skuCertificateupdate([{ ...obj, numberYearNow: value, companyId, skuId, type }])
          break;
        case 'numberPost':
          await skuCertificateupdate([{ ...obj, numberPost: value, companyId, skuId, type }])
          break;
        case 'numberYearSign':
          await skuCertificateupdate([{ ...obj, numberYearSign: value, companyId, skuId, type }])
          break;
        case 'numberContract':
          await skuCertificateupdate([{ ...obj, numberContract: value, companyId, skuId, type }])
          break;
        case 'numberStartStr':
          await skuCertificateupdate([{ ...obj, numberStartStr: value, companyId, skuId, type }])
          break;
        default:
          break;
      }
    },
    change (id) {
      this.selectJson.map((item) => {
        if (item.id == id) {
          this.imgUrl = item.templateUrl
        }
      })
    },
    setOpacity (flg) {
      this.getSelectData()
      this.getData()
      this.dialogVisible = flg;
    },
    handleClose () {
      this.dialogVisible = false;
    },
    getSelectData () {
      getCertificateInfo({
        templateType: 1
      }).then(res => {
        let { code, data, message } = res;
        if (code === 0) {
          this.selectJson = data;
          if (this.form.graduationId) {
            this.change(this.form.graduationId)
          }
        } else {
          this.$message.error(message);
        }
      })
    },
    sure () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            id: this.editParams.id,
            certificateGraduationId: this.form.graduationId,
            certificateContent: this.form.certificateContent
          }
          skuupdate(params).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$emit('success')
              this.$message.success('配置成功');
              this.dialogVisible = false
            } else {
              this.$message.error(message);
            }
          })
        }
      })
    }
  },
  watch: {
    editParams: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue) {
          this.imgUrl = ''
          if (this.editParams.certificateGraduationId !== undefined) {
            this.form.graduationId = Number(this.editParams.certificateGraduationId)
            this.$set(this.form, 'certificateContent', this.editParams.certificateContent)
            // this.form.certificateContent =
          } else {
            this.form = {}
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
.el-dialog__body {
  // max-height: 50vh;
  overflow-y: auto;
}
.red {
  color: red;
  margin-left: 130px;
}
</style>
